module.exports = __webpack_public_path__ + "static/piucinque-61a6f39cd326afbc74e72061a68a44d6.jpg";